'use client';

import { useTranslations } from 'next-intl';
import { useContext } from 'react';
import { useWatch } from 'react-hook-form';

import { Currency } from '@/shared/model/Currency';

import './product-detail.scss';
import { useCartStore, getPriceValueTranslation } from '@/entities/cart';
import { ProductDetailContext } from './provider';

export const ProductDetailInfoPrice = () => {
    const { hash, formMethods } = useContext(ProductDetailContext);
    const t = useTranslations();
    const getItemPrices = useCartStore((s) => s.getItemPrices);

    const selectedVariant = useWatch({ control: formMethods.control, name: 'variant' });
    const priceHash = selectedVariant ?? hash;

    const price = priceHash ? getItemPrices(priceHash) : null;
    const priceText = price
        ? getPriceValueTranslation({
              amount: price.itemPrice.amount,
              currency: price.itemPrice.currency as Currency,
              t,
          })
        : '';

    return (
        <div className="product-detail__info-price" data-testid="product-detail-price">
            <strong data-testid="product-detail-price-value" data-value={price?.itemPrice.amount}>
                {priceText}
            </strong>
            {/*false && <span className="product-detail__info-price-original">{priceText}</span>*/}
        </div>
    );
};
